/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Delete_TitleInputs */

const en_recipe_delete_title = /** @type {(inputs: Recipe_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this recipe?`)
};

const de_recipe_delete_title = /** @type {(inputs: Recipe_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Rezept löschen?`)
};

/**
* | output |
* | --- |
* | "Delete this recipe?" |
*
* @param {Recipe_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_delete_title = /** @type {((inputs?: Recipe_Delete_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Delete_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_delete_title(inputs)
	return en_recipe_delete_title(inputs)
});